import {
  useTheme,
  Box,
  CircularProgress,
  Typography,
  Button,
} from "@mui/material";

import WheelComponent from "./SpinningWheelWidget";
import { useRef } from "react";
import { win } from "../../Assets";

const     Spinner = ({
  dataItem,
  filterData,
  BackData,
  spinLoading,
  Loading,
  updateLimit,
  handleRestart,
  question,
  setQuestion,
}) => {
  const theme = useTheme();

  const soundRef = useRef();
  const playActionSound = () => {
    const audioPlayer = soundRef.current;
    audioPlayer?.play();
  };

  return (
    <>
      <Box>
        <Box
          sx={{
            position: "absolute",
            left: "10%",
            top: "10%",
          }}
        ></Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h3"
            align="center"
            style={{
              fontWeight: 500,
              color: `${question && "#ffffff"}`,
            }}
          >
            {question && "Congratulation"}
          </Typography>
        </Box>
        <audio ref={soundRef}>
          <source src={win} />
        </audio>
        {spinLoading && (
          <Box
            sx={{
              position: "absolute",
              left: "50%",
              top: "50%",
            }}
          >
            <CircularProgress sx={{ margin: "auto" }} />
          </Box>
        )}
        {!spinLoading && (
          <Box sx={{ position: "relative" }}>
            {!Loading && !question && (
              <WheelComponent
                segments={dataItem?.map((e) => e.id)}
                segImg={dataItem?.map((e) => e.img)}
                segColors={dataItem?.map((e) => e.color)}
                segSize={dataItem?.map((e) => e.size)}
                buttonIcon={BackData?.button}
                logoIcon={BackData?.logo}
                result={filterData?.map((e) => e)}
                data={dataItem?.map((e) => e)}
                frame={BackData?.frame}
                BackDataSize={BackData?.size}
                // winningSegment={win}
                onFinished={(winner) => {
                  setTimeout(() => {
                    updateLimit(dataItem[winner].id, dataItem[winner].limit);
                    setQuestion(dataItem[winner]);
                    playActionSound();
                  }, 500);
                }}
                primaryColor="white"
                contrastColor="white"
                buttonText=""
                isOnlyOnce={false}
                size={275} // wheel radius (was 180)
                imgSize={150} // segment image size (was 100)
                imgX={90} // x-offset (was 65)
                imgY={-80}
                upDuration={100}
                downDuration={1000}
                fontFamily="Arial"
                segmentFontSize={theme.typography.body1.fontSize + "px"}
              />
            )}
          </Box>
        )}

        {question && (
          <Box
            style={{
              textAlign: "center",
              padding: 5,
              overflow: "auto",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              // backgroundColor: `${BackData?.rewardColor}`,
            }}
          >
            <img src={question?.img} alt="" width={200} />
            <Box sx={{ pb: 2 }} width={1}>
              <Button
                fullWidth
                variant="contained"
                sx={{
                  mt: 4,
                  py: 1.8,
                  fontSize: "18px",
                  fontWeight: 500,
                  borderRadius: "30px",
                  textTransform: "none",
                  backgroundColor: "#d89f84",
                  "&:hover": { backgroundColor: "#c55c2bff" },
                }}
                onClick={handleRestart}
              >
                <Typography
                  sx={{ color: "white", fontWeight: 700, fontSize: "30px" }}
                >
                  Retake Quiz
                </Typography>
              </Button>
            </Box>
          </Box>
        )}
      </Box>
    </>
  );
};

export default Spinner;
